import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IGetAllUserPermissionsResponse } from '../models'

export class GetAllUserPermissionsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/userPermission/GetAllUserPermission',
      requesterInfo,
    })
  }

  public async getAllPermissions(): Promise<IGetAllUserPermissionsResponse> {
    return await this.getAsync<IGetAllUserPermissionsResponse>()
  }
}
